import * as angular from "angular";
import {DataHubService} from "../modules/DataHubModule";
import {IComponentController} from "angular";
import {QbTermsDto} from "../model/QbTermsDto";
import {DisposeBag} from "../modules/DisposeBag";

class QbPendingController implements IComponentController {
    private guid: string;
    count: number;
    private disposeBag = new DisposeBag();

    constructor(private $dataHub: DataHubService, private $scope) {
        $dataHub.onQbPendingChanged(val => this.count=val, this.disposeBag);
        $dataHub.onConnected(this.reload, this.disposeBag);
    }

    reload = () => {
        this.$dataHub.qbPendingSubscribe(this.guid).catch(this.$dataHub.defaultErrorHandler);
    };

    $onInit(): void {
    }
    $onDestroy?() {
        this.disposeBag.finalize();
    }
}

export default angular.module('component.qbPending', [])
    .component('qbPending', {
        template: require('./QbPending.html'),
        controller: QbPendingController,
        bindings: {
            guid: '=',
            hideIfZero: '=',
            caption: '@'
        }
    }).name;
